const digest = '6235732cedf140150fa35543c8b4b1f673c913a7aa705821c553ecff158e5875';
const css = `._returnHomeWrapper_o763o_1 a{text-decoration:underline}._emailBlue_o763o_5{color:#006fcf}._confirmTitle_o763o_9{line-height:1}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'returnHomeWrapper': '_returnHomeWrapper_o763o_1', 'emailBlue': '_emailBlue_o763o_5', 'confirmTitle': '_confirmTitle_o763o_9' };
export const returnHomeWrapper = '_returnHomeWrapper_o763o_1';
export const emailBlue = '_emailBlue_o763o_5';
export const confirmTitle = '_confirmTitle_o763o_9';
export { css, digest };